export default "__VITE_ASSET__C_v2ywr4__"